import { render, staticRenderFns } from "./DocumentProperties.vue?vue&type=template&id=076e406e&scoped=true&"
import script from "./DocumentProperties.vue?vue&type=script&lang=js&"
export * from "./DocumentProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e406e",
  null
  
)

export default component.exports